/* eslint-disable @typescript-eslint/no-var-requires */
require("dotenv").config();

// Toggle this to point the stage config's backend URLs at your local
// server instead of manually editing each URL below.
// 1 = local backend (localhost:8081), 0 = stage backend
const USE_LOCAL_BACKEND = 0;
const BACKEND_BASE_URL = USE_LOCAL_BACKEND === 1
  ? "http://localhost:8081"
  : "https://yoddha-service-stage.adobe.io";

if (process.env.REACT_APP_NODE_ENV === "prod") {
  module.exports = {
    REACT_APP_PORT: 8080,
    REACT_APP_OKTA_CLIENT_ID: process.env.REACT_APP_PROD_OKTA_CLIENT_ID,
    REACT_APP_OKTA_ISSUER_ID: "https://adobe.okta.com",
    REACT_APP_OKTA_TESTING: process.env.REACT_APP_OKTA_TESTING || false,
    CCP_URL: "https://sd-prod.my.connect.aws/ccp-v2",
    CCP_LOGIN_URL:
      "https://adobe.okta.com/app/amazon_aws/exk1zuweljb0JyRy80h8/sso/saml?RelayState=https://us-east-1.console.aws.amazon.com/connect/federate/ad9f2ef3-66f4-498a-ae57-76fe2f583f9b?destination=%2Fconnect%2Fccp-v2",
    CONNECT_API_URL: "https://connect.us-east-1.amazonaws.com",
    CCP_CH_URL: "https://yoddha-service.adobe.io",
    CCP_API_END_POINT: "https://yoddha-service.adobe.io",
    AWS_REGION: "us-east-1",
    // CCP_CH_URL:'http://localhost:3000/api/getConversationHistory/customer'
    // ECM
    REACT_APP_ECM_BASE_URL: "https://oac-ecm-dev.adobe.io",
    REACT_APP_ENT_CUSTOMER_DEEPLINK_URL:
      "https://adobe-estg.crm.dynamics.com/main.aspx?pagetype=entityrecord&etn=ent_organizationcontact&id=",
    REACT_APP_ENT_CASE_DEEPLINK_URL:
      "https://adobe-estg.crm.dynamics.com/main.aspx?pagetype=entityrecord&etn=incident&id=",
    REACT_APP_ECM_SEARCH_CUSTOMER_URL:
      "https://adobe-estg.crm.dynamics.com/main.aspx?appid=2c849ca1-2117-ea11-a811-000d3a593e5e&forceUCI=1&pagetype=webresource&webresourceName=ent_%2Fcustomersearch.html",
    // CCM
    REACT_APP_CCM_BASE_URL: "https://oac-ccm-dev.adobe.io",
    REACT_APP_CUSTOMER_DEEPLINK_URL:
      "https://adobe-istg.crm.dynamics.com/main.aspx?app=CustomerOne&pagetype=entityrecord&etn=contact&id=",
    REACT_APP_CASE_DEEPLINK_URL:
      "https://adobe-istg.crm.dynamics.com/main.aspx?app=CustomerOne&pagetype=entityrecord&etn=incident&id=",
    REACT_APP_ADD_CUSTOMER_DEEPLINK_URL:
      "https://adobe-istg.crm.dynamics.com/main.aspx?app=CustomerOne&newWindow=true&pagetype=entityrecord&etn=contact",
    REACT_APP_CCM_UCI_DYNAMIC_URL:
      "https://adobe-istg.crm.dynamics.com/main.aspx?app=QuickApp&navbar=off&pagetype=entityrecord&etn=incident",
    HENDRIX_DOMAIN: "https://hendrix360.stage.adobe.com",
    CM_DOMAIN: "https://casemgmt-qe.msgbotcon.adobe.com",
    CIP_DOMAIN: "https://yoddha-service.adobe.io",
    PDC_QUERY_URL: "https://yoddha-service.adobe.io//api/pdc/v1/queue",
    PDC_HOTKEYS_URL: "https://oac-pdc-dev.adobe.io/api/v1/pdc/read/hotkeys",
    CCP_LOGOUT_URL: "https://adb-oac-dev.my.connect.aws",
    // PDC_TRANSLATE_URL: "https://convservice-dev.adobe.io/api/translate/chat",
    // PDC_BASE_URL: "https://oac-pdc-dev.adobe.io",
    VPN_SET_INTERVAL_TIME: 30000,
    VPN_SET_TIMEOUT_VALUE: 3000,
    PDC_TRANSLATE_URL: "https://convservice-dev.adobe.io/api/translate/chat",
    PDC_BASE_URL: "https://yoddha-service.adobe.io",
    GENAI_MIDDLEWARE_URL:
      "https://genai-core-middleware-qa.adobe.io/api/v1/gen-ai", // 'http://localhost:3001/api/v1/gen-ai'
    FG_ENDPOINT_CONVO_SUMMARY:
      "https://p13n-stage.adobe.io/fg/api/v3/feature?clientId=conversationSummary&meta=false",
    FG_ENDPOINT_AA:
      "https://p13n-stage.adobe.io/fg/api/v3/feature?clientId=AdobeAnswers&meta=false",
    FG_ENDPOINT_AAFeedback:
      "https://p13n-stage.adobe.io/fg/api/v3/feature?clientId=AdobeAnswersFlags&meta=true",
    FG_ENDPOINT_RU:
      "https://p13n-stage.adobe.io/fg/api/v3/feature?clientId=oac-ru-widget&meta=true",
    PERSONALIZATION_DOMAIN: "https://oc-ru-stage.adobe.io", //'http://localhost:8082'//
    FG_ENDPOINT_RTS: "https://p13n-stage.adobe.io/fg/api/v3/feature?meta=true",
    ENDPOINT_RTS_PROCESSOR: "https://oc-rtcs-processor-dev.adobe.io/api/v1",
    FG_ENDPOINT_OAC_FEATURE_FLAGS:
      "https://p13n-stage.adobe.io/fg/api/v3/feature?clientId=oac-feature-flags&meta=true",
    SD_DOMAIN: 'https://yoddha-service.adobe.io',
    CF_DOMAIN: 'https://d1cez2yv5e3ll5.cloudfront.net',
    SNOW_DOMAIN: 'https://adobe.service-now.com',
  };

} else {
  module.exports = {
    REACT_APP_PORT: 8080,
    REACT_APP_OKTA_CLIENT_ID: process.env.REACT_APP_STAGE_OKTA_CLIENT_ID,
    REACT_APP_OKTA_ISSUER_ID: "https://adobe.okta.com",
    REACT_APP_OKTA_TESTING: process.env.REACT_APP_OKTA_TESTING || false,
    CCP_URL: "https://sd-stage.my.connect.aws/ccp-v2",
    CCP_LOGIN_URL:
      "https://adobe.okta.com/app/amazon_aws/exk1zge75gev9o4PH0h8/sso/saml?RelayState=https://us-east-1.console.aws.amazon.com/connect/federate/cb2f629e-aba6-4f6d-bae2-ab9bfeadb575?destination=%2Fconnect%2Fccp-v2",
    CONNECT_API_URL: "https://connect.us-east-1.amazonaws.com",
    CCP_CH_URL: BACKEND_BASE_URL,
    CCP_API_END_POINT: BACKEND_BASE_URL,
    AWS_REGION: "us-east-1",
    // CCP_CH_URL:'http://localhost:3000/api/getConversationHistory/customer'
    // ECM
    REACT_APP_ECM_BASE_URL: "https://oac-ecm-dev.adobe.io",
    REACT_APP_ENT_CUSTOMER_DEEPLINK_URL:
      "https://adobe-estg.crm.dynamics.com/main.aspx?pagetype=entityrecord&etn=ent_organizationcontact&id=",
    REACT_APP_ENT_CASE_DEEPLINK_URL:
      "https://adobe-estg.crm.dynamics.com/main.aspx?pagetype=entityrecord&etn=incident&id=",
    REACT_APP_ECM_SEARCH_CUSTOMER_URL:
      "https://adobe-estg.crm.dynamics.com/main.aspx?appid=2c849ca1-2117-ea11-a811-000d3a593e5e&forceUCI=1&pagetype=webresource&webresourceName=ent_%2Fcustomersearch.html",
    // CCM
    REACT_APP_CCM_BASE_URL: "https://oac-ccm-dev.adobe.io",
    REACT_APP_CUSTOMER_DEEPLINK_URL:
      "https://adobe-istg.crm.dynamics.com/main.aspx?app=CustomerOne&pagetype=entityrecord&etn=contact&id=",
    REACT_APP_CASE_DEEPLINK_URL:
      "https://adobe-istg.crm.dynamics.com/main.aspx?app=CustomerOne&pagetype=entityrecord&etn=incident&id=",
    REACT_APP_ADD_CUSTOMER_DEEPLINK_URL:
      "https://adobe-istg.crm.dynamics.com/main.aspx?app=CustomerOne&newWindow=true&pagetype=entityrecord&etn=contact",
    REACT_APP_CCM_UCI_DYNAMIC_URL:
      "https://adobe-istg.crm.dynamics.com/main.aspx?app=QuickApp&navbar=off&pagetype=entityrecord&etn=incident",
    HENDRIX_DOMAIN: "https://hendrix360.stage.adobe.com",
    CM_DOMAIN: "https://casemgmt-qe.msgbotcon.adobe.com",
    CIP_DOMAIN: BACKEND_BASE_URL,
    PDC_QUERY_URL: `${BACKEND_BASE_URL}/api/pdc/v1/queue`,
    PDC_HOTKEYS_URL: "https://oac-pdc-dev.adobe.io/api/v1/pdc/read/hotkeys",
    CCP_LOGOUT_URL: "https://adb-oac-dev.my.connect.aws",
    // PDC_TRANSLATE_URL: 'https://convservice-dev.adobe.io/api/translate/chat',
    // PDC_BASE_URL: 'https://oac-pdc-dev.adobe.io',
    VPN_SET_INTERVAL_TIME: 30000,
    VPN_SET_TIMEOUT_VALUE: 3000,
    DISABLE_VPN_CHECK: USE_LOCAL_BACKEND === 1, // VPN gate can't resolve against localhost
    PDC_TRANSLATE_URL: "https://convservice-dev.adobe.io/api/translate/chat",
    PDC_BASE_URL: BACKEND_BASE_URL,
    GENAI_MIDDLEWARE_URL:
      "https://genai-core-middleware-qa.adobe.io/api/v1/gen-ai", // 'http://localhost:3001/api/v1/gen-ai'
    FG_ENDPOINT_CONVO_SUMMARY:
      "https://p13n-stage.adobe.io/fg/api/v3/feature?clientId=conversationSummary&meta=false",
    FG_ENDPOINT_AA:
      "https://p13n-stage.adobe.io/fg/api/v3/feature?clientId=AdobeAnswers&meta=false",
    FG_ENDPOINT_AAFeedback:
      "https://p13n-stage.adobe.io/fg/api/v3/feature?clientId=AdobeAnswersFlags&meta=true",
    FG_ENDPOINT_RU:
      "https://p13n-stage.adobe.io/fg/api/v3/feature?clientId=oac-ru-widget&meta=true",
    PERSONALIZATION_DOMAIN: "https://oc-ru-stage.adobe.io", //'http://localhost:8082'//
    FG_ENDPOINT_RTS: "https://p13n-stage.adobe.io/fg/api/v3/feature?meta=true",
    ENDPOINT_RTS_PROCESSOR: "https://oc-rtcs-processor-dev.adobe.io/api/v1",
    FG_ENDPOINT_OAC_FEATURE_FLAGS:
      "https://p13n-stage.adobe.io/fg/api/v3/feature?clientId=oac-feature-flags&meta=true",
    SD_DOMAIN: BACKEND_BASE_URL,
    CF_DOMAIN: 'https://d15rfsjmidm8jo.cloudfront.net',
    SNOW_DOMAIN: 'https://adobeqa.service-now.com',
    EMAIL_TEMPLATES_URL: `${BACKEND_BASE_URL}/api/email/v1/message-templates`,
    SNOW_UPDATE_CASE_URL: `${BACKEND_BASE_URL}/api/email/v1/update-service-now`
  };

}
